import { render, staticRenderFns } from "./CdChat.vue?vue&type=template&id=244e259b&scoped=true"
import script from "./CdChat.vue?vue&type=script&lang=js"
export * from "./CdChat.vue?vue&type=script&lang=js"
import style0 from "./CdChat.vue?vue&type=style&index=0&id=244e259b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e259b",
  null
  
)

export default component.exports